export const securityTitle = `Comprehensive DevOps Services for Modern Businesses`;

export const securityDescription = `
From cloud migration to CI/CD automation, we provide end-to-end DevOps solutions. 
Our services include infrastructure setup, container orchestration, monitoring, 
security, and ongoing support. We help you build, deploy, and scale with confidence.
`;

export const securityWorks = [
  'Cloud Infrastructure (AWS, GCP, Azure)',
  'Kubernetes & Docker Orchestration',
  'CI/CD Pipelines & Automation',
];
